import Logo from '@webapp/common/assets/icons/pay/logo.svg';
import Methods from '@webapp/common/assets/icons/pay/methods.svg';

import { Advs } from '@webapp/landing/src/components/ui/advs';

import css from './payment-variants.css';

const methods = ['Банковским переводом по счету на оплату', 'Онлайн в личном кабинете'];

export const PaymentVariants: FC = () => (
    <div className={css.paymentVariants}>
        <h1 className={css.header}>Тарифы</h1>
        <h2 className={css.subheader}>Способы оплаты</h2>
        <p className={css.description}>Мы принимаем оплаты от физических и юридических лиц следующими способами:</p>
        <Advs className={css.adv} items={methods} />
        <div className={css.paymentCards}>
            <div className={css.paymentCard}>
                <Logo width='200px' height='80px' />
                <Methods />
            </div>
        </div>
    </div>
);
